// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3DC06","consentsList":"PatientConsents_consentsList__DSSll","consentsListEmpty":"PatientConsents_consentsListEmpty__3li7m"};